import { UIComponentViewImpl } from '../uicomponentview';
import { VerticalListComponentProps } from './verticallistcomponent';
import { UIComponentState } from '../uicomponent';
import { VerticalListCSSStyle } from './verticallistcss';
import * as React from 'react';

export class VerticalListViewImpl<T> extends UIComponentViewImpl<T>
{
    draw(props: VerticalListComponentProps<T>, state: UIComponentState, cssStyle: VerticalListCSSStyle): JSX.Element | boolean
    {
        super.draw(props, state, cssStyle);

        return(
            <table style={cssStyle.getWrapperCSSStyle()}>
            {
                props.listViewModel.getHeader()
            } 
            <tbody style={{width: "100%", height: "100%", display: "flex", flexFlow: "row wrap"}}>
                {
                    props.listViewModel.getListOfDatas().map((entry, index)=>
                    {
                        return props.listViewModel.getView(entry, index);
                    }
                )
                }
            </tbody>
            </table>
       );
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/verticallist/verticallistview.tsx